import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useCustomReportPage } from "./hook/customReportPage.hook";
import { CustomReportPageView } from "./view/customReportPage.view";
export var CustomReportPage = function () {
    var p = useCustomReportPage();
    return (_jsx(CustomReportPageView, { loading: p.loading, toast: p.toast, setToast: p.setToast, reportCard: p.reportCard, newDownData: p.newDownData, dataSeries: p.dataSeries, dataCategories: p.dataCategories, productsData: p.productsData, onClickMonthReport: p.onClickMonthReport, openReport: p.openReport, filterCalendar: p.filterCalendar, clearCalendar: p.clearCalendar }));
};
